import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb6557f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ef-infoTags" }
const _hoisted_2 = {
  key: 0,
  class: "fa-regular fa-circle-check"
}
const _hoisted_3 = {
  key: 1,
  class: "fa-regular fa-circle-xmark"
}
const _hoisted_4 = {
  key: 2,
  class: "fa-solid fa-circle-info"
}

import {storeSystem} from "@/stores/system";
import {storeToRefs} from "pinia";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


const _storeSystem = storeSystem();
const {infoTags} = storeToRefs(_storeSystem);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, {
      name: "slide",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(infoTags), (infoTag) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(`ef-infoTags__tag -${infoTag.type}`),
            key: infoTag.id
          }, [
            (infoTag.type === 'success')
              ? (_openBlock(), _createElementBlock("i", _hoisted_2))
              : _createCommentVNode("", true),
            (infoTag.type === 'failure')
              ? (_openBlock(), _createElementBlock("i", _hoisted_3))
              : _createCommentVNode("", true),
            (infoTag.type === 'neutral')
              ? (_openBlock(), _createElementBlock("i", _hoisted_4))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(infoTag.text), 1)
          ], 2))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})